import './style.scss';
import * as React from 'react';
import { Button } from 'react-bootstrap';
// import Select, { Option } from 'rc-select';
import { Users } from 'Interfaces/User';
import { ClientPersistInterface } from 'Interfaces/ClientPersistInterface';
import { ActionTransmitInterface } from 'Interfaces/ActionTransmitInterface';
import { useAppDispatch } from 'index';
import { navigateAddModal, navigateRemoveModal } from 'actions/navigationAction';
import { ShareActionsModalProps } from 'views/Modals/ShareActionsModal';
import { ModalComponentNames, ModalInterface } from 'Interfaces/ModalInterface';
import { getLocalization } from '../../../../global/global';

interface Props {
  users: Users;
  clientPersist: ClientPersistInterface;
  link: string;
  questionId: string;
  tableFormId: string;
  id: string;
  getSharerEmail: (id: string, signal: AbortSignal) => Promise<Response>;
  sendActionEmail: (actionTransmit: ActionTransmitInterface, signal: AbortSignal) => Promise<Response>;
}

const Transmit = (props: Props) => {
  const dispatch = useAppDispatch();

  const showModal = () => {
    const modalProps: ModalInterface<ShareActionsModalProps> = {
      component: ModalComponentNames.ShareActionsModal,
      props: {
        onClose: () => { dispatch(navigateRemoveModal(ModalComponentNames.ShareActionsModal)); },
        link: props.link,
        questionId: props.questionId,
        tableFormId: props.tableFormId,
        id: props.id,
        auto: false,
      }
    };
    dispatch(navigateAddModal(modalProps));
  };

  return (
    <React.Fragment>
      <Button
        size={'sm'}
        onClick={() => {
          showModal();
        }}
        className={'float-end'}
      >
        {getLocalization('share')}
      </Button>
    </React.Fragment>
  );
};

export default Transmit;
